// API Configuration
export const API_CONFIG = {
  SUPABASE_URL: 'https://iasrrcndbdelwetoljkp.supabase.co',
  SUPABASE_ANON_KEY: process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imlhc3JyY25kYmRlbHdldG9samtwIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzQyNzI4MDAsImV4cCI6MjA0OTg0ODgwMH0.Ej8Ej8Ej8Ej8Ej8Ej8Ej8Ej8Ej8Ej8Ej8Ej8Ej8Ej8',
  API_TIMEOUT: 30000,
  RETRY_ATTEMPTS: 3
}

// App Configuration
export const APP_CONFIG = {
  APP_NAME: 'SALT App',
  VERSION: '1.0.0',
  BUILD_NUMBER: '1',
  SUPPORT_EMAIL: 'support@saltapp.com'
}

// User Roles
export const USER_ROLES = {
  USER: 'user',
  ADMIN: 'admin',
  SUPER_ADMIN: 'super_admin'
} as const

// Task Status
export const TASK_STATUS = {
  ASSIGNED: 'assigned',
  IN_PROGRESS: 'in_progress',
  COMPLETED: 'completed',
  OVERDUE: 'overdue'
} as const

// Event Types
export const EVENT_TYPES = {
  TASK_ASSIGNED: 'task_assigned',
  TASK_DUE: 'task_due',
  TASK_OVERDUE: 'task_overdue',
  TASK_COMPLETED: 'task_completed',
  EVENT_CREATED: 'event_created',
  EVENT_UPDATED: 'event_updated',
  EVENT_REMINDER: 'event_reminder',
  MESSAGE_RECEIVED: 'message_received',
  MENTION_RECEIVED: 'mention_received',
  GROUP_INVITATION: 'group_invitation',
  GROUP_MEMBER_JOINED: 'group_member_joined',
  GROUP_MEMBER_LEFT: 'group_member_left',
  CURRICULUM_SHARED: 'curriculum_shared'
} as const

// Notification Types
export const NOTIFICATION_TYPES = {
  INFO: 'info',
  SUCCESS: 'success',
  WARNING: 'warning',
  ERROR: 'error'
} as const

// Form Validation
export const VALIDATION_RULES = {
  EMAIL: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  PASSWORD_MIN_LENGTH: 8,
  NAME_MIN_LENGTH: 2,
  NAME_MAX_LENGTH: 50
}

// Date Formats
export const DATE_FORMATS = {
  DISPLAY: 'MMM dd, yyyy',
  INPUT: 'yyyy-MM-dd',
  TIME: 'HH:mm',
  DATETIME: 'MMM dd, yyyy HH:mm'
}

// Pagination
export const PAGINATION = {
  DEFAULT_PAGE_SIZE: 20,
  MAX_PAGE_SIZE: 100
}

// File Upload
export const FILE_UPLOAD = {
  MAX_SIZE: 10 * 1024 * 1024, // 10MB
  ALLOWED_TYPES: ['image/*', 'application/pdf', 'text/plain'],
  IMAGE_MAX_SIZE: 5 * 1024 * 1024 // 5MB
}

// Cache Keys
export const CACHE_KEYS = {
  USER_PROFILE: 'user_profile',
  USER_SESSIONS: 'user_sessions',
  GROUPS: 'groups',
  TASKS: 'tasks',
  EVENTS: 'events',
  NOTIFICATIONS: 'notifications'
}

// Error Messages
export const ERROR_MESSAGES = {
  NETWORK_ERROR: 'Network error. Please check your connection.',
  UNAUTHORIZED: 'You are not authorized to perform this action.',
  NOT_FOUND: 'The requested resource was not found.',
  VALIDATION_ERROR: 'Please check your input and try again.',
  SERVER_ERROR: 'Server error. Please try again later.',
  UNKNOWN_ERROR: 'An unexpected error occurred.'
}

// Success Messages
export const SUCCESS_MESSAGES = {
  PROFILE_UPDATED: 'Profile updated successfully.',
  TASK_COMPLETED: 'Task completed successfully.',
  EVENT_CREATED: 'Event created successfully.',
  MESSAGE_SENT: 'Message sent successfully.',
  GROUP_CREATED: 'Group created successfully.'
} 